import styled from 'styled-components'

import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'

import { Colors, FontSize } from '~/styles'

const StyledDialog = styled(Dialog)`
  div.MuiDialog-container.MuiDialog-scrollPaper {
    div.MuiDialog-paperWidthLg {
      width: ${(props) => props.width}vw;
      max-width: none;
      ${(props) =>
  props.height ? `height: ${props.height}${props.heightType ? props.heightType : 'vh'};` : ''}
    }
    div.MuiDialog-paperWidthXl {
      width: ${(props) => props.width}vw;
    }
  }
`

export const Header = styled(MuiDialogTitle)`
  &.MuiDialogTitle-root {
    padding: 5px 15px;
    background-color: ${(props) => (props.whiteheader === 'true' ? Colors.white : Colors.softBlue)};
  }
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const DivTitle = styled.div`
  width: auto;
  display: flex;
  min-width: 6.5%;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled.h1`
  margin: 0;
  font-size: ${FontSize.mediumLarge}px;
  font-weight: bold;
  color: ${(props) => (props.whiteheader === 'true' ? Colors.black : Colors.pureWhite)};
  font-family: 'Open Sans', sans-serif;
`

export const Subtitle = styled.h2`
  margin-bottom: 32px;
  font-size: ${FontSize.medium}px;
`

export const Label = styled.p`
  color: ${Colors.darkGrey};
  font-size: 14px;
  margin-top: 0;
  font-weight: 400;
  margin-bottom: 12px;
  letter-spacing: 0;

  span {
    color: ${Colors.red};
  }
`

const FormContainer = styled.div`
  gap: 12px;
  width: 100%;
  display: grid;
  align-items: center;
  grid-template-columns: ${(props) => (props.gridTemplateColumns ? props.gridTemplateColumns : '1fr')};
`
const UploadContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  height: min-content;
  flex-direction: column;
  background: ${Colors.paleBlue};
`

const ActionContainer = styled.div`
  gap: 12px;
  display: flex;
  justify-content: flex-end;
`

const LoadingContainer = styled.div`
  width: 100%;
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default {
  Title,
  Label,
  Header,
  DivTitle,
  Subtitle,
  StyledDialog,
  FormContainer,
  TitleContainer,
  UploadContainer,
  ActionContainer,
  LoadingContainer,
}